/*
  PDP info-block tweaks — click-to-copy SKU.
  Design handoff "PDP info-block tweaks" Change 2.

  Behaviour:
    Click the SKU chip area → copy the SKU text to clipboard, briefly
    show a "Copied" affordance. Falls back to a hidden textarea + execCommand
    on browsers that don't expose navigator.clipboard.

  Loaded by sections/main-product.liquid (defer).
*/
(function () {
  'use strict';

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(ta);
        ok ? resolve() : reject(new Error('execCommand failed'));
      } catch (err) {
        reject(err);
      }
    });
  }

  function handleClick(button) {
    var codeEl = button.querySelector('.pdp-sku-code');
    if (!codeEl) return;
    var sku = codeEl.textContent.trim();
    if (!sku) return;

    copyText(sku).then(function () {
      button.classList.add('is-copied');
      window.setTimeout(function () {
        button.classList.remove('is-copied');
      }, 1500);
    }).catch(function (err) {
      // Last-resort visual nudge — log and let the user select manually.
      // No silent failure: the user gets clear feedback if it didn't take.
      console.warn('pdp-sku-copy: copy failed', err);
    });
  }

  function bind(root) {
    var buttons = (root || document).querySelectorAll('[data-pdp-sku-copy]');
    buttons.forEach(function (btn) {
      if (btn.dataset.pdpSkuCopyBound === '1') return;
      btn.dataset.pdpSkuCopyBound = '1';
      btn.addEventListener('click', function () { handleClick(btn); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }

  // Re-bind after variant switch (theme re-renders the SKU node).
  document.addEventListener('variant:change', function () { bind(document); });
  document.addEventListener('shopify:section:load', function () { bind(document); });
})();
